<template>
  <div class="pagar-container">
        <appbar-view></appbar-view>

        <div class="pagar-scroll-content">
        <div>
          <div class="direcciones-container p-3 bg-gray-50 rounded-lg shadow mb-6">
            <h3 class="flex items-center gap-2 font-semibold text-sm mb-2 text-gray-800">
              <span class="flex items-center justify-center w-6 h-6 rounded-full bg-green-600 text-white text-xs">
                1
              </span>


              <span>Dirección de entrega</span>


              <span class="px-2 py-0.5 text-xs rounded-full bg-yellow-100 text-yellow-700 font-medium">
                Selecciona una
              </span>
            </h3>


            <div v-if="isLoading" class="text-gray-500 text-sm">
              Cargando direcciones...
            </div>


            <div v-else-if="direcciones.length === 0" class="text-gray-500 text-sm">
              No se encontraron direcciones.
            </div>


            <!-- CONTENEDOR CON SCROLL -->
            <!-- CONTENEDOR CON SCROLL -->
            <div v-else class="max-h-64 overflow-y-auto pr-1 grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div
              v-for="direccion in direccionesConMapa"
              :key="direccion.CTEDIR_CODIGO_K"
              @click="seleccionarDireccion(direccion)"
              :class="[
                'p-3 rounded-lg border text-xs transition-all cursor-pointer',
                'bg-white hover:shadow-md active:scale-[0.98]',
                direccionSeleccionada?.CTEDIR_CODIGO_K === direccion.CTEDIR_CODIGO_K
                  ? 'border-green-500 bg-green-50 ring-2 ring-green-300'
                  : 'border-gray-200 hover:border-gray-300'
              ]"

              
            ><p class="text-[10px] text-red-400">
              {{ direccion.CTEDIR_CODIGO_K === direccionSeleccionada?.CTEDIR_CODIGO_K ? 'SELECCIONADA' : '' }}
            </p>
                <!-- NOMBRE / COMERCIAL -->
               
                <p class="font-semibold text-gray-800 truncate">
                  {{  direccion.CTECLI_RAZONSOCIAL }}
                </p>
          
                <!-- CALLE -->
                <p class="text-gray-600 truncate">
                  {{ direccion.CTEDIR_CALLE }}
                  <span v-if="direccion.CTEDIR_CALLENUMEXT">
                    #{{ direccion.CTEDIR_CALLENUMEXT }}
                  </span>
                </p>

                <!-- COLONIA / CP -->
                <p class="text-gray-500">
                  {{ direccion.CTEDIR_COLONIA }} · CP {{ direccion.CTEDIR_CP }}
                </p>

                <!-- COORDENADAS (informativo) -->
                <p class="text-[10px] text-gray-400 mt-1">
                  📍 {{ direccion.MAP_Y }}, {{ direccion.MAP_X }}
                </p>
              </div>
            </div>

            
          </div>
        </div>
        <div class="max-w-md mx-auto p-4 border border-gray-200 rounded-xl shadow-lg mb-6 space-y-4">
          <h3 class="flex items-center gap-2 font-semibold text-sm mb-2 text-gray-800">
            <span class="flex items-center justify-center w-6 h-6 rounded-full bg-green-600 text-white text-xs">
              2
            </span>


            <span>Usar Creditos</span>


            <span class="px-2 py-0.5 text-xs rounded-full bg-yellow-100 text-yellow-700 font-medium">


            </span>
          </h3>
          <div class="flex items-center space-x-3">
            <img src="https://mvexpress.mx/images/mvsimple.png" alt="MV Coins"
              class="w-10 h-10 rounded-full border border-gray-300" />


            <label class="flex items-center cursor-pointer">
              <div class="relative">
                <input type="checkbox" v-model="useMvCoins" @change="calculateTotal" class="sr-only" />
                <div class="w-12 h-6 rounded-full shadow-inner transition-colors duration-300"
                  :class="useMvCoins ? 'bg-green-500' : 'bg-gray-300'"></div>
                <div
                  class="dot absolute left-1 top-1 w-4 h-4 bg-white rounded-full shadow transform transition-transform duration-300"
                  :class="useMvCoins ? 'translate-x-6' : 'translate-x-0'"></div>
              </div>
              <span class="ml-3 text-gray-700 font-medium"></span>
            </label>





          </div>


          <!-- Cantidad de MV Coins a usar -->
          <transition name="slide-y" appear>
            <div v-if="useMvCoins" class="space-y-2">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                Cantidad de MV Coins a usar
              </label>


              <input type="number" v-model.number="mvCoinsToUse" @input="onMvCoinsChange" :max="user.mvCoins" min="0"
                step="1" class="w-full px-3 py-2 border border-gray-300 rounded-lg" />


              <!-- Coins usados -->
              <!-- Resumen MV Coins usados -->
              <div class="flex items-center justify-between bg-green-50 border border-green-200 rounded-lg p-3">
                <div class="flex items-center gap-3">
                  <img src="https://mvexpress.mx/images/mvsimple.png" alt="MV Coins" class="w-8 h-8 rounded-full" />


                  <div>
                    <p class="text-sm font-semibold text-green-700">
                      Usando MV Coins
                    </p>
                    <p class="text-xs text-green-600">
                      {{ mvCoinsToUse }} de {{ user.mvCoins }} disponibles
                    </p>
                  </div>
                </div>


                <span class="text-lg font-bold text-green-700">
                  {{ mvCoinsToUse }}
                </span>
              </div>


              <!-- Equivalencia en pesos -->
              <p class="text-xs text-gray-500">
                Equivalente a:
                <strong class="text-green-600">
                  ${{ (mvCoinsToUse / MV_COIN_RATE).toFixed(2) }} MXN
                </strong>
              </p>


              <!-- Total original -->
              <div class="flex justify-between text-sm text-gray-600 pt-2 border-t">
                <span>Total original:</span>
                <span>${{ roundedTotal.toFixed(2) }} MXN</span>
              </div>


              <!-- Total final -->
              <div class="flex justify-between text-base font-semibold text-green-700">
                <span>Total a pagar:</span>
                <span>${{ totalFinalCalculado.toFixed(2) }} MXN</span>
              </div>
            </div>
          </transition>



          <!-- Total después de MV Coins -->
          <div v-if="useMvCoins"
            class="flex justify-between items-center p-4 bg-orange-50 border border-gray-200 rounded-xl">
            <span class="text-gray-700 font-semibold">Total después de MV Coins:</span>
            <div class="flex items-baseline space-x-1">
              <span class="text-2xl font-bold text-orange-600">{{
                totalFinalCalculado.toFixed(2)
              }}</span>
              <span class="text-sm font-medium text-gray-500">MXN</span>
            </div>
          </div>
        </div>


        <!-- 🔹 Selección de método de pago -->
        <!-- 🔹 Selección de método de pago -->
        <div class="max-w-md mx-auto p-4 space-y-4">
          <div class="flex items-center gap-3 mb-2">
            <span class="flex items-center justify-center w-6 h-6 rounded-full bg-green-600 text-white text-xs">
              3
            </span>
            <h2 class="text-xl font-semibold text-gray-800">Selecciona un método de pago</h2>
          </div>


          <div class="grid grid-cols-2 gap-4">
            <!-- Tarjeta deshabilitada -->
            <div
              class="border-2 rounded-lg p-4 flex flex-col items-center justify-center text-center bg-gray-200 border-gray-300 opacity-50 cursor-not-allowed">
              <v-icon size="36" color="gray">mdi-credit-card</v-icon>
              <p class="font-medium mt-2 text-center">Tarjeta (OpenPay)</p>
            </div>


            <!-- Efectivo habilitado -->
            <div :class="[
              'border-2 rounded-lg p-4 text-center select-none transition-all flex flex-col items-center justify-center',
              !puedeLevantarPedido
                ? 'opacity-50 pointer-events-none border-gray-300'
                : metodo === 'efectivo'
                  ? 'border-green-500 bg-green-100 cursor-pointer'
                  : 'border-gray-300 cursor-pointer'
            ]" @click="puedeLevantarPedido && (metodo = 'efectivo')">
              <v-icon size="36" color="green darken-2">mdi-cash</v-icon>
              <p class="font-medium mt-2">Efectivo al recibir</p>
            </div>
          </div>


          <!-- Botón de acción -->
          <div class="mt-4">
            <!-- Checkbox solo para efectivo -->
            <label v-if="metodo === 'efectivo'" class="flex items-center mb-3 cursor-pointer">
              <input type="checkbox" v-model="confirmarPedido" class="mr-2" />
              <span class="text-sm text-gray-700">Confirmo que pagaré al recibir mis productos</span>
            </label>
            <p v-if="direccionSeleccionada && !isDentroHorarioPermitido()"
              class="text-xs text-red-600 text-center mt-2">
              ⏰ Los pedidos se reciben:
              <br />
              Lun–Vie hasta 6:00 PM · Sábados hasta 5:00 PM
            </p>

            <!-- Botón -->
            <button :disabled="!confirmarPedido || !puedeLevantarPedido || isProcessingPayment" @click="continuarPago"
              class="w-full py-3 text-white font-semibold rounded-lg transition-all flex justify-center items-center" :class="confirmarPedido && puedeLevantarPedido && !isProcessingPayment
                ? 'bg-green-600 hover:bg-green-700'
                : 'bg-gray-400 cursor-not-allowed'
                ">
              <template v-if="isProcessingPayment && metodo === 'efectivo'">
                <v-progress-circular indeterminate color="white" size="24" class="mr-2"></v-progress-circular>
                Procesando...
              </template>
              <template v-else>
                Confirmar pedido 💵
              </template>
            </button>


          </div>
        </div>




        <div v-if="showFormOpenPay" class="fixed inset-0 bg-white bg-opacity-50 flex items-center justify-center z-50">
          <div class="bg-white p-6 rounded-lg w-96 shadow-lg relative animate-fade-in">



            <button @click="cancelarPagoOpenPay" class="absolute top-2 right-2 text-gray-500 hover:text-red-500"
              title="Cerrar">
              ✕
            </button>


            <h2 class="text-xl font-bold mb-4 text-center">
              Pago con tarjeta
            </h2>


            <form id="payment-form" @submit.prevent="confirmPaymentOpenPay">
              <div class="mb-2">
                <label class="block text-sm">Número de tarjeta</label>
                <input type="text" data-openpay-card="card_number" v-model="card.card_number"
                  placeholder="4111111111111111" class="border p-2 w-full rounded" required />
              </div>


              <div class="mb-2">
                <label class="block text-sm">Nombre en tarjeta</label>
                <input type="text" data-openpay-card="holder_name" v-model="card.holder_name" placeholder="Juan Pérez"
                  class="border p-2 w-full rounded" required />
              </div>


              <div class="flex space-x-2 mb-2">
                <div class="w-1/2">
                  <label class="block text-sm">Mes (MM)</label>
                  <input type="text" data-openpay-card="expiration_month" v-model="card.expiration_month"
                    placeholder="MM" maxlength="2" class="border p-2 w-full rounded" required />
                </div>


                <div class="w-1/2">
                  <label class="block text-sm">Año (AA)</label>
                  <input type="text" data-openpay-card="expiration_year" v-model="card.expiration_year" placeholder="AA"
                    maxlength="2" class="border p-2 w-full rounded" required />
                </div>
              </div>


              <div class="mb-2">
                <label class="block text-sm">CVV</label>
                <input type="text" data-openpay-card="cvv2" v-model="card.cvv2" placeholder="123" maxlength="4"
                  class="border p-2 w-full rounded" required />
              </div>


              <p class="mt-3 font-semibold text-center">
                💳 Total a pagar:
                <span class="text-green-600">
                  ${{ totalFinalCalculado.toFixed(2) }}
                </span>
              </p>


              <button type="submit" :disabled="isProcessingPayment" class="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded mt-3 w-full flex justify-center items-center" :class="{'opacity-50 cursor-not-allowed': isProcessingPayment}">
                <template v-if="isProcessingPayment">
                  <v-progress-circular indeterminate color="white" size="20" class="mr-2"></v-progress-circular>
                  Procesando...
                </template>
                <span v-else>Confirmar pago</span>
              </button>


              <button type="button" @click="cancelarPagoOpenPay" :disabled="isProcessingPayment"
                class="bg-gray-400 hover:bg-gray-500 text-white px-4 py-2 rounded mt-2 w-full">
                Cancelar
              </button>
            </form>
          </div>
        </div>

        </div>
        <bottom-navigation />
  </div>
</template>
<style scoped>
html,
body,
#app {
  height: 100%;
  overflow: hidden;
}

.pagar-container {
  background-color: white;
  height: 100%;
}

.pagar-scroll-content {
  height: calc(100vh - (64px + env(safe-area-inset-top, 30px)));
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: calc(env(safe-area-inset-bottom) + 80px);
}
</style>



<script>
/* global OpenPay */
import Swal from "sweetalert2";
import appbarView from "./appbar/appbarView.vue";
import BottomNavigation from "./submenu/BottomNavigation.vue";
import { useUserStore } from "@/stores/userStore"; // ✅ importa el store
import api from "@/services/api";
import { createCartStore } from "@/stores/cart";


const cartStore = createCartStore();

export default {
  setup() { },
  components: { appbarView, BottomNavigation },
  data() {
    return {
      metodo: 'efectivo',
      userStore: useUserStore(),
      cartStore,
      carrito: cartStore.state.cart,
      confirmarPedido: false,
      snackbar: {
        show: false,
        message: "",
        color: "green",
      },
      MV_COIN_RATE: 1,

      roundedTotal: 0,
      mvCoinsToUse: 0,
      useMvCoins: false,
      direcciones: [],
      direccionSeleccionada: null,
      isLoading: false,
      isProcessingPayment: false,
    };
  },

  watch: {
    direccionSeleccionada(dir) {
      console.log("Dirección:", dir?.dia);
      console.log("Puede levantar pedido:", this.puedeLevantarPedido);
    }
  },

  computed: {
    user() {
      return this.userStore.user;
    },

    puedeLevantarPedido() {
      if (!this.direccionSeleccionada || !this.direccionSeleccionada.dia) {
        return false;
      }

      const normalize = (str) =>
        str
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toUpperCase()
          .trim();

      const diasSemana = [
        "DOMINGO",
        "LUNES",
        "MARTES",
        "MIERCOLES",
        "JUEVES",
        "VIERNES",
        "SABADO",
      ];

      const hoy = diasSemana[new Date().getDay()];

      // 🔹 Normalizar string de días
      const raw = normalize(this.direccionSeleccionada.dia);

      // 🔹 SIEMPRE tratar "-" y "," como LISTA
      let diasPermitidos = [];

      if (raw.includes("-") || raw.includes(",")) {
        diasPermitidos = raw
          .split(/[-,]/)
          .map(d => d.trim())
          .filter(Boolean);
      } else {
        diasPermitidos = [raw];
      }

      const diaValido = diasPermitidos.includes(hoy);
      const horarioValido = this.isDentroHorarioPermitido();

      return diaValido && horarioValido;
    },

    totalFinalCalculado() {
      const total = this.roundedTotal || 0;

      if (!this.useMvCoins) return total;

      const coins = parseFloat(this.mvCoinsToUse) || 0;
      const descuentoMXN = coins / this.MV_COIN_RATE;
      const descuentoFinal = Math.min(descuentoMXN, total);

      return parseFloat((total - descuentoFinal).toFixed(2));
    },




    direccionesConMapa() {
      return this.direcciones.filter(d =>
        d.MAP_X != null &&
        d.MAP_Y != null &&
        d.MAP_X !== 0 &&
        d.MAP_Y !== 0
      )
    }


  },



  mounted() {
    // 🚫 Si no hay sesión, fuera
    if (!this.user) {
      this.$router.replace("/login");
      return;
    }


    // 🛒 Carrito (si aún no lo migras a Pinia)
    this.loadCartData();
    this.calculateCartTotal();


    // 📍 Direcciones
    if (!this.direcciones.length) {
      this.obtenerDirecciones();
    }


    // 🔐 Aviso de privacidad
    this.verificarPolitica();


    // 📅 Notificar días de entrega
    if (Array.isArray(this.user.direcciones) && this.user.direcciones.length) {
      const normalize = (str) =>
        str
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .trim();


      const diasSemana = [
        "DOMINGO",
        "LUNES",
        "MARTES",
        "MIERCOLES",
        "JUEVES",
        "VIERNES",
        "SABADO",
      ];


      const hoy = normalize(diasSemana[new Date().getDay()]);


      const dias = this.user.direcciones
        .map((d) => {
          if (!d.dia) return null;


          return d.dia
            .split(",")
            .map((dia) =>
              normalize(dia) === hoy ? "HOY" : dia.trim()
            )
            .join(", ");
        })
        .filter(Boolean)
        .join(" | ");


      if (dias) {
        this.showNotification(
          `📦 Tus días de entrega son: ${dias}`,
          "info"
        );
      }
    }
  },



  methods: {
    showNotification(message, color = "success") {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },


    async verificarPolitica() {
      await this.obtenerNuevaData(); // <-- obtiene datos actualizados del usuario
      if (!this.user?.politica_privacidad_aceptada) {
        alert("Debes aceptar el aviso de privacidad antes de continuar.");
        this.$router.replace("/aviso-privacidad"); // Usar router es más fluido en Apps móviles
      }
    },


    continuarPago() {
      if (!this.puedeLevantarPedido) {
        Swal.fire(
          "Pedido no permitido",
          "Hoy no es un día habilitado para levantar pedido en esta dirección.",
          "warning"
        );
        return;
      }


      if (!this.metodo) {
        Swal.fire("Selecciona un método de pago", "", "info");
        return;
      }


      if (this.metodo === "openpay") {
        this.abrirPagoOpenPay();
      } else if (this.metodo === "efectivo") {
        this.confirmarPagoEfectivo();
      }
    },



    async obtenerDirecciones() {
      try {
        if (!this.user?.cliente) return;


        this.isLoading = true;
        const response = await api.get(`/find-direccion/${this.user.cliente}`);
        this.direcciones = response.data || [];
      } catch (error) {
        console.error("Error al obtener direcciones:", error);
      } finally {
        this.isLoading = false;
      }
    },


    seleccionarDireccion(direccion) {
      this.direccionSeleccionada = direccion;
      console.log("Dirección seleccionada:", direccion);
      localStorage.setItem("direccionSeleccionada", JSON.stringify(direccion));
    },

    // Cargar carrito desde localStorage
    loadCartData() {
      this.carrito = JSON.parse(localStorage.getItem("cart")) || [];
      this.calculateCartTotal();
    },


    calculateCartTotal(productos = this.carrito) {
      this.roundedTotal = parseFloat(
        productos
          .reduce((sum, item) => {
            const precio = parseFloat(
              item.promo_price ||
              item.precio_con_descuento ||
              item.precio_desc ||
              item.price ||
              0
            );
            return sum + precio * (item.quantity || 1);
          }, 0)
          .toFixed(2)
      );
    },


    validateMvCoins() {
      if (this.mvCoinsToUse < 0) this.mvCoinsToUse = 0;
      if (this.mvCoinsToUse > (this.user?.mvCoins || 0))
        this.mvCoinsToUse = this.user.mvCoins || 0;
    },


    onMvCoinsChange() {
      this.validateMvCoins();
    },


    async confirmarPagoEfectivo() {
      try {
        if (!this.carrito || this.carrito.length === 0) {
          Swal.fire("Carrito vacío", "Agrega productos antes de pagar.", "warning");
          return;
        }

        const user = JSON.parse(localStorage.getItem("user")) || {};

        const productos = this.carrito.map((item) => ({
          id: item.id || item.producto_id,

          PRODUC_CODIGO_K: item.sku || String(item.id),
          pround: item.pround ?? 'CJA',
          linea_prod_id: item.linea_prod_id,

          quantity: Number(item.quantity ?? 1),

          // 🔥 PRECIO FINAL (EL QUE PAGA)
          price: Number(item.price ?? 0),

          // 🔥 PRECIO LISTA (CLAVE PARA ECORE)
          precio_lista: Number(
            item.precio_lista ??
            item.precio_original ??
            item.price ??
            0
          ),

          // 🔥 PROMO (SOLO ID)
          promo_id: item.promo_id ?? null,

          // 🔥 IMPUESTOS
          iva: Number(item.iva ?? item.iva16 ?? 0),
          ieps: Number(item.ieps ?? 0),
        }));


        console.log("🛒 CARRITO REAL:");
        this.carrito.forEach(i => {
          console.log({
            sku: i.sku,
            iva: i.iva,
            ieps: i.ieps,
            price: i.price
          });
        });

        console.log(productos)

        
    if (!this.direccionSeleccionada) {
  Swal.fire(
    "Dirección requerida",
    "Selecciona una dirección de entrega antes de continuar.",
    "warning"
  );
  return;
}

const direccion = this.direccionSeleccionada;

          this.isProcessingPayment = true; // ⏳ INICIA CARGA

          const datosPedido = {
            cliente_id: user.cliente,
            productos,
            total: this.totalFinalCalculado,
            metodo_pago: "efectivo",

            // 🔥 ESTA ES LA CLAVE
            CTEDIR_CODIGO_K: direccion.CTEDIR_CODIGO_K,

            mvCoinsToUse: this.mvCoinsToUse || 0,
            udnCliente: user.udn,
            email: user.email,
            observaciones: "Pago en efectivo por cobrar al repartidor",
          };

        const urlBackend = "https://mvexpress.mx/api/crear-sesion-efectivo";

        const resp = await api.post(urlBackend, datosPedido, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        });

        console.log("📦 Respuesta ECORE (Efectivo):", resp);

        // ✅ ÉXITO REAL
        // ✅ ÉXITO REAL
        if (resp.status === 200) {
          await Swal.fire({
            icon: "success",
            title: "Pedido creado correctamente",
            text: "Tu pedido fue registrado correctamente.",
            confirmButtonText: "Ver mis pedidos",
          });

          this.cartStore.resetState();   // 👈 ESTA ES LA CLAVE
          this.carrito = this.cartStore.state.cart;
          this.$router.push("/pedidos");

          return;
        }


        // ❌ backend respondió pero no fue OK
        console.error("❌ Respuesta completa del servidor:", resp.data);
        Swal.fire(
          "Error",
          (resp.data?.mensaje || "No se pudo crear el pedido.") + 
          // 👇 Agregamos esto para ver si el backend mandó más info oculta
          (resp.data ? `\n\nDetalles técnicos: ${JSON.stringify(resp.data).slice(0, 200)}...` : ""),
          "error"
        );

      } catch (err) {
        console.error("❌ Error en confirmarPagoEfectivo:", err);
        const errorData = err.response?.data;
        Swal.fire(
          "Error",
          (errorData?.mensaje || err.message || "Ocurrió un error al procesar el pedido.") +
          (errorData ? `\n\nDetalles: ${JSON.stringify(errorData)}` : ""),
          "error"
        );
      } finally {
        this.isProcessingPayment = false; // ⏳ TERMINA CARGA
      }
    },

    // ----- OpenPay -----
    abrirPagoOpenPay() {
      OpenPay.setId("mrhcqairad7fcz7e5v4s"); // reemplazar
      OpenPay.setApiKey("pk_e75ad998669a4dff984f734d13d46653"); // reemplazar
      OpenPay.setSandboxMode(true);


      try {
        this.deviceSessionId = OpenPay.deviceData.setup("payment-form", "device_session_id");
        console.log("deviceSessionId generado:", this.deviceSessionId);
      } catch (err) {
        console.warn("deviceData.setup error:", err);
      }


      this.showFormOpenPay = true;
    },


    cancelarPagoOpenPay() {
      this.showFormOpenPay = false;
      this.card = {
        holder_name: "",
        card_number: "",
        expiration_month: "",
        expiration_year: "",
        cvv2: "",
      };
      this.deviceSessionId = null;
    },


    async obtenerNuevaData() {
      try {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        if (!storedUser?.id) return;


        const response = await api.get(`https://mvexpress.mx/api/get-mvcoins/${storedUser.id}`);
        
        // 🔥 CORRECCIÓN: Fusionamos los datos en lugar de reemplazarlos
        // Esto evita que se borre 'politica_privacidad_aceptada' si el endpoint solo devuelve monedas
        this.userStore.user = { ...this.userStore.user, ...response.data }; 
        
      } catch (error) {
        console.error("Error al obtener los datos del usuario:", error);
        
        // 🛡️ VALIDACIÓN EXTRA: Si el token venció o el usuario no existe, mandar al login
        if (error.response?.status === 401 || error.response?.status === 404) {
          this.$router.replace("/login");
        }
      }
    },


    async confirmPaymentOpenPay() {
      try {
        if (!this.carrito?.length) {
          Swal.fire("Carrito vacío", "Agrega productos antes de pagar.", "warning");
          return;
        }


        this.card.expiration_month = String(this.card.expiration_month || "").padStart(2, "0").slice(-2);
        this.card.expiration_year = String(this.card.expiration_year || "").padStart(2, "0").slice(-2);

        this.isProcessingPayment = true; // ⏳ INICIA CARGA


        const cardData = { ...this.card };
        const tokenResp = await new Promise((resolve, reject) =>
          OpenPay.token.create(cardData, resolve, reject)
        );


        if (!tokenResp?.data?.id) throw new Error("No se generó token de OpenPay.");


        const token_id = tokenResp.data.id;


        if (!this.deviceSessionId) {
          try {
            this.deviceSessionId = OpenPay.deviceData.setup("payment-form", "device_session_id");
          } catch {
            console.error('Error')


          }
        }


        const productos = this.carrito.map(item => ({
          id: item.id || item.producto_id,
          nombre: item.nombre || item.name || "Producto sin nombre",
          cantidad: item.quantity || 1,
          precio: parseFloat(
            item.promo_price ||
            item.precio_con_descuento ||
            item.precio_desc ||
            item.price ||
            0
          ),
        }));


        const datosPedido = {
          cliente_id: this.user.cliente || null,
          productos,
          total: this.totalFinalCalculado,
          metodo_pago: "card",
          token_id,
          device_session_id: this.deviceSessionId,
          CTEDIR_CODIGO_K: this.direccionSeleccionada?.CTEDIR_CODIGO_K || null,
          mvCoinsToUse: this.mvCoinsToUse || 0,
          email: this.user.email || null,
          udnCliente: this.user.udn || null,
        };


        const resp = await api.post("https://mvexpress.mx/api/crear-sesion-openpay", datosPedido, {
          headers: { "Content-Type": "application/json" },
        });

        console.log("📦 Respuesta ECORE (OpenPay):", resp);

        const data = resp.data || {};
        if (["completed"].includes(data.status || data.charge_status)) {
          Swal.fire("Pago exitoso", "Tu pago fue procesado correctamente.", "success");
          localStorage.removeItem("cart");
          this.carrito = [];
          this.cancelarPagoOpenPay();
          this.$router.push("/SucessView");
          return;
        }


        if (["pending", "in_progress"].includes(data.charge_status)) {
          Swal.fire("Pago pendiente", "Tu pago está en proceso o requiere confirmación.", "info");
          this.cancelarPagoOpenPay();
          return;
        }


        Swal.fire("Error", data.message || "No se pudo completar el pago.", "error");
        this.cancelarPagoOpenPay();
      } catch (err) {
        const msg = err?.data?.description || err?.response?.data?.error?.description || err.message || "Error al procesar el pago.";
        Swal.fire("Error", msg, "error");
      } finally {
        this.isProcessingPayment = false; // ⏳ TERMINA CARGA
      }
    },
   isDentroHorarioPermitido() {
    // 1️⃣ Ajuste de Zona Horaria (México Central)
    const now = new Date(new Date().toLocaleString("en-US", {timeZone: "America/Mexico_City"}));
    
    const day = now.getDay(); // 0 = dom, 1-5 = lun-vie, 6 = sáb
    const hour = now.getHours();
    const minutes = now.getMinutes();
    const currentMinutes = hour * 60 + minutes;

    console.log(`🕒 Hora local detectada: ${hour}:${minutes} (Día: ${day})`);

    // ✅ Domingo (0)
    if (day === 0) {
      // Solo permitir pedidos en domingo al usuario específico
      if (this.user?.email === 'jorgepenagos50@gmail.com') {
        return true;
      }
      return false;
    }

    // 🕒 Lunes a Viernes (1 al 5)
    // Límite: 11:45 PM (según tu código anterior 23:45)
    if (day >= 1 && day <= 5) {
      const limiteSemana = 23 * 60 + 45; 
      return currentMinutes <= limiteSemana;
    }

    // 🕒 Sábado (6)
    // Límite: 5:00 PM -> (17 * 60) = 1020 minutos
    if (day === 6) {
      const limiteSabado = 17 * 60; 
      return currentMinutes <= limiteSabado;
    }

    return false;
}

  },
};
</script>
